import { render, staticRenderFns } from "./ProjectTabLead.vue?vue&type=template&id=2879ee96&scoped=true"
import script from "./ProjectTabLead.vue?vue&type=script&lang=ts"
export * from "./ProjectTabLead.vue?vue&type=script&lang=ts"
import style0 from "./ProjectTabLead.vue?vue&type=style&index=0&id=2879ee96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2879ee96",
  null
  
)

export default component.exports